import React from 'react';
import { Flex, Box, Absolute } from 'rebass';

import { COLOR } from '../../Theme';

const DiagonalTableCell = ({ left, right }) => (
  <Box>
    <svg style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }}>
      <line
        x1="100%"
        y1="100%"
        x2="0"
        y2="0"
        style={{ stroke: `${COLOR.borderGrey}`, strokeWidth: 1 }}
      />
    </svg>
    <Absolute top={0} left={0} style={{ height: '100%', width: '100%' }}>
      <Flex justifyContent={'flex-end'} alignItems={'center'} px={12} style={{ height: '50%' }}>
        {right}
      </Flex>
      <Flex alignItems={'center'} px={12} style={{ height: '50%' }}>
        {left}
      </Flex>
    </Absolute>
  </Box>
);

export default DiagonalTableCell;
